// elements/ice-skater-42.js
import { LitElement } from "lit";
import { unsafeStatic, html } from "lit/static-html.js";
import { i18n as i18n2 } from "@lingui/core";

// src/raw/ice-skater/locales/nb/messages.mjs
var messages = JSON.parse('{"icon.title.iceskater":"Sk\xF8ytel\xF8per"}');

// src/raw/ice-skater/locales/en/messages.mjs
var messages2 = JSON.parse('{"icon.title.iceskater":"Ice skater"}');

// src/raw/ice-skater/locales/fi/messages.mjs
var messages3 = JSON.parse('{"icon.title.iceskater":"Luistelija"}');

// src/utils/i18n.ts
import { i18n } from "@lingui/core";
var supportedLocales = ["en", "nb", "fi", "da", "sv"];
var defaultLocale = "en";
var detectByBrand = () => {
  let value;
  switch (process.env.NMP_BRAND) {
    case "FINN":
      value = "nb";
      break;
    case "TORI":
      value = "fi";
      break;
    case "BLOCKET":
      value = "sv";
      break;
    case "DBA":
      value = "da";
      break;
    default:
      value = "en";
  }
  return value;
};
var detectByHost = () => {
  var _a;
  const hostname = (_a = document == null ? void 0 : document.location) == null ? void 0 : _a.hostname;
  if (hostname.includes("finn")) {
    return "nb";
  } else if (hostname.includes("tori")) {
    return "fi";
  } else if (hostname.includes("blocket")) {
    return "sv";
  } else if (hostname.includes("dba")) {
    return "da";
  } else {
    return defaultLocale;
  }
};
var getSupportedLocale = (usedLocale) => {
  return supportedLocales.find(
    (locale) => usedLocale === locale || usedLocale.toLowerCase().includes(locale)
  ) || detectByHost();
};
function detectLocale() {
  var _a;
  if (typeof window === "undefined") {
    const serverLocale = detectByBrand();
    return getSupportedLocale(serverLocale);
  }
  try {
    const htmlLocale = (_a = document == null ? void 0 : document.documentElement) == null ? void 0 : _a.lang;
    const hostLocale = detectByHost();
    if (!supportedLocales.includes(htmlLocale)) {
      console.warn("Unsupported locale set in html lang tag, falling back to detection by hostname");
      return getSupportedLocale(hostLocale);
    }
    return getSupportedLocale(htmlLocale != null ? htmlLocale : hostLocale);
  } catch (e) {
    console.warn("could not detect locale, falling back to source locale", e);
    return defaultLocale;
  }
}
var getMessages = (locale, enMsg, nbMsg, fiMsg) => {
  if (locale === "nb")
    return nbMsg;
  if (locale === "fi")
    return fiMsg;
  return enMsg;
};
var activateI18n = (enMessages, nbMessages, fiMessages) => {
  const locale = detectLocale();
  const messages4 = getMessages(locale, enMessages, nbMessages, fiMessages);
  i18n.load(locale, messages4);
  i18n.activate(locale);
};

// elements/ice-skater-42.js
activateI18n(messages2, messages, messages3);
var IconIceSkater42 = class extends LitElement {
  render() {
    const title = i18n2.t({ message: `Ice skater`, id: "icon.title.iceskater", comment: "Title for IceSkater icon" });
    return html`<svg xmlns="http://www.w3.org/2000/svg"width="42"height="28"fill="none"viewBox="0 0 42 28" part="w-icon-ice-skater-42-part">${unsafeStatic(`<title>${title}</title>`)}<path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9.896 20.5h5.875a4.88 4.88 0 0 0 3.604-1.596l1.759-1.934.775.386a3.25 3.25 0 0 1 1.799 2.908v5.924"></path><path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M26.958 26.188v-5.924a6.46 6.46 0 0 0-3.551-5.79l3.128-3.443a1.625 1.625 0 0 0-1.202-2.719h-9.75a1.625 1.625 0 0 0 0 3.25h6.076l-4.686 5.156a1.63 1.63 0 0 1-1.203.532H9.896M30.208 7.5a2.844 2.844 0 1 0 0-5.687 2.844 2.844 0 0 0 0 5.687"></path><path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M30.208 24.563a1.625 1.625 0 0 1-1.625 1.625h-8.125M11.52 23.75a1.625 1.625 0 0 1-1.624-1.625V14m3.25 3.25v3.25m10.562 2.438h3.25"></path></svg>`;
  }
};
if (!customElements.get("w-icon-ice-skater-42")) {
  customElements.define("w-icon-ice-skater-42", IconIceSkater42);
}
export {
  IconIceSkater42
};
//# sourceMappingURL=ice-skater-42.js.map
